module.exports = __webpack_public_path__ + "media/images/icn-rss-footer-e327f0d3.png";